/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Copy = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M3 4.5C3 3.67157 3.67157 3 4.5 3H16.5C17.3284 3 18 3.67157 18 4.5V16.5C18 17.3284 17.3284 18 16.5 18H4.5C3.67157 18 3 17.3284 3 16.5V4.5ZM4.5 4.5V16.5H16.5V4.5H4.5Z"
                        fill={color}
                    />
                    <path
                        d="M19.5 19.5V7H21V19.5C21 20.3284 20.3284 21 19.5 21H8V19.5H19.5Z"
                        fill={color}
                    />
                </svg>
        );
    };
